<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Overview">
    <page-loader v-if="loading" :hasActions="true"></page-loader>

    <div v-if="!loading" class="giga-content_container">
      <div class="row">
        <!-- GENERAL INFOS CARD -->
        <div class="col-xl-7 col-lg-6">
          <div class="giga-card giga-card_equal_height">
            <div class="giga-card_wrap">
              <h3 class="giga-card_title">{{ $t("general_informations") }}</h3>
              <div class="giga-card_content">
                <ul class="giga-card_list">
                  <li class="giga-card_list_item inline-info">
                    <label>{{ $t("simulation_name") }}</label>
                    <span>{{ getSimulation.name }}</span>
                  </li>
                  <li class="giga-card_list_item inline-info">
                    <label>{{ $t("classic_volume") }}</label>
                    <span
                      >{{ getSimulation.classicVolume | formatNumber }} kWh
                      cumac</span
                    >
                  </li>
                  <li class="giga-card_list_item inline-info">
                    <label>{{ $t("precarious_volume") }}</label>
                    <span
                      >{{ getSimulation.precarityVolume | formatNumber }} kWh
                      cumac</span
                    >
                  </li>
                  <li class="giga-card_list_item inline-info">
                    <label>{{ $t("economic_valorisation") }}</label>
                    <span
                      >€
                      {{
                        getSimulation.economicValorisation | formatNumber
                      }}</span
                    >
                  </li>
                  <li class="giga-card_list_item inline-info">
                    <label>{{ $t("number_of_operations") }}</label>
                    <span>{{ getSimulation.numberOfOperations }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- CONTACT CARD -->
        <div class="col-xl-5 col-lg-6" v-if="getContacts.consultant">
          <div class="giga-card giga-card_equal_height">
            <div class="giga-card_wrap">
              <h3 class="giga-card_title">Votre contact</h3>
              <div class="giga-card_content giga-card_flex">
                <div class="giga-card_content_wrap">
                  <div class="giga-card_profile">
                    <div class="giga-card_profile_thumb">
                      <div class="profile_thumb"></div>
                    </div>
                    <div class="giga-card_profile_infos">
                      <ul class="giga-card_profile_infos_list">
                        <li class="giga-card_profile_info_item">
                          <div class="giga-card_profile_info_content">
                            <h5 class="giga-card_profile_name">
                              {{
                                getContacts.consultant.firstName +
                                  " " +
                                  getContacts.consultant.lastName
                              }}
                            </h5>
                            <span class="giga-card_profile_function"
                              >Consultant</span
                            >
                          </div>
                        </li>
                        <li class="giga-card_profile_info_item">
                          <div class="giga-card_profile_info_content">
                            <a class="giga-card_profile_email" href="">{{
                              getContacts.consultant.mail
                            }}</a>
                          </div>
                        </li>
                        <li class="giga-card_profile_info_item">
                          <div class="giga-card_profile_info_content">
                            <span class="giga-card_profile_tel">{{
                              getContacts.consultant.telephone
                            }}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <b-button
                    class="giga-card_profile_send-button"
                    :href="'mailto:' + getContacts.consultant.mail"
                    >Envoyer un E-mail</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- AGENCY / USER -->
        <div
          class="col-lg-12 mt-5 mb-5"
          v-if="userInfo.clientType === this.USER_TYPE.B2B2B"
        >
          <div class="giga-card">
            <h3 class="giga-card_title">
              {{ $t("agency") }} / {{ $t("users") }}
            </h3>
            <div class="giga-card_content assign-div">
              <ul class="giga-card_list">
                <li class="giga-card_list_item inline-info">
                  <label style="flex: 0 0 10%;">{{ $t("agency") }} : </label>
                  <span
                    v-if="
                      getSimulation.users &&
                        getSimulation.users.length > 0 &&
                        getSimulation.users[0] !== null &&
                        getSimulation.users[0].agence &&
                        !editAgence
                    "
                    :style="readOnly"
                    style="flex: 0 0 auto;"
                  >
                    <span v-if="getSimulation.agence">
                      {{ getSimulation.agence.raisonSocial }}</span
                    >
                    <span v-else>
                      {{ getSimulation.users[0].agence.raisonSocial }}
                    </span>
                  </span>
                  <span
                    v-if="
                      getSimulation.users &&
                        getSimulation.users.length > 0 &&
                        getSimulation.users[0] !== null &&
                        !getSimulation.users[0].agence &&
                        !editAgence
                    "
                    :style="readOnly"
                    style="flex: 0 0 auto;"
                    >AUCUNE AGENCE</span
                  >
                  <div class="giga-fields">
                    <div
                      class="giga-input_field full-field"
                      v-if="
                        !getSimulation.users ||
                          getSimulation.users.length === 0 ||
                          editAgence
                      "
                    >
                      <div class="input-field_area">
                        <select
                          id="agence"
                          v-model="$v.userAgenceForm.agence.$model"
                          class="small-input"
                          @change="
                            onChangeAgence($v.userAgenceForm.agence.$model)
                          "
                          style="width: 300px;"
                          :class="{
                            'field-hasError': $v.userAgenceForm.agence.$invalid
                          }"
                        >
                          <option v-if="userInfo.admin" :value="-1"
                            >AUCUNE AGENCE</option
                          >
                          <option
                            v-for="agence of agences"
                            :key="agence.id"
                            :value="agence"
                            >{{ agence.raisonSocial }}</option
                          >
                        </select>
                        <div
                          class="validation-field-holder"
                          v-if="
                            $v.userAgenceForm.agence.$anyDirty &&
                              $v.userAgenceForm.agence.$invalid
                          "
                        >
                          <small
                            v-if="!$v.userAgenceForm.agence.required"
                            class="form-text text-danger"
                          >
                            {{ $t("required_field") }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="giga-card_list_item inline-info">
                  <label style="flex: 0 0 10%;">{{ $t("users") }} : </label>
                  <span
                    v-if="
                      getSimulation.users &&
                        getSimulation.users.length > 0 &&
                        !editUser
                    "
                    class="label-users"
                    :style="readOnlyOnUsers"
                    style="flex: 0 0 auto;"
                  >
                    {{ usernameUsers }}
                  </span>
                  <div class="giga-fields">
                    <div
                      class="giga-input_field full-field"
                      v-if="
                        !getSimulation.users ||
                          getSimulation.users.length === 0 ||
                          editUser
                      "
                    >
                      <div class="input-field_area">
                        <multiselect
                          id="user"
                          v-model="$v.userAgenceForm.users.$model"
                          :multiple="true"
                          :options="users"
                          label="email"
                          track-by="id"
                          :searchable="false"
                          :closeOnSelect="false"
                          :class="{
                            'field-hasError': $v.userAgenceForm.users.$invalid
                          }"
                          :user-select="true"
                          :disableUser="disableUserByEmail"
                          :disabled="!this.userInfo.admin && isVIEWER"
                        >
                          <template slot="caret">
                            <div
                              class="multiselect__select d-flex align-items-center justify-content-center"
                            >
                              <div>
                                <b-icon icon="chevron-down"></b-icon>
                              </div>
                            </div>
                          </template>
                        </multiselect>
                        <div
                          class="validation-field-holder"
                          v-if="
                            $v.userAgenceForm.users.$anyDirty &&
                              $v.userAgenceForm.users.$invalid
                          "
                        >
                          <small
                            v-if="!$v.userAgenceForm.users.required"
                            class="form-text text-danger"
                          >
                            {{ $t("required_field") }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="half-footer right-content giga-button">
                <button
                  v-if="
                    !getSimulation.users ||
                      getSimulation.users.length === 0 ||
                      editUser ||
                      editAgence
                  "
                  :disabled="$v.userAgenceForm.$invalid"
                  class="giga-green_button no-icon"
                  @click="onPersistSubscription()"
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- USER -->
        <div class="col-lg-12 mt-5 mb-5" v-if="isNotB2B2B">
          <div class="giga-card">
            <h3 class="giga-card_title">
              {{ $t("users") }}
            </h3>
            <div class="giga-card_content">
              <ul class="giga-card_list">
                <li class="giga-card_list_item inline-info">
                  <label style="flex: 0 0 10%;">{{ $t("users") }} : </label>
                  <span
                    v-if="
                      getSimulation.users &&
                        getSimulation.users.length > 0 &&
                        !editUser
                    "
                    class="label-users"
                    :style="readOnlyOnUsers"
                    style="flex: 0 0 auto;"
                  >
                    {{ usernameUsers }}
                  </span>
                  <div class="giga-fields">
                    <div
                      class="giga-input_field full-field"
                      v-if="
                        !getSimulation.users ||
                          getSimulation.users.length === 0 ||
                          editUser
                      "
                    >
                      <div class="input-field_area">
                        <multiselect
                          id="user"
                          v-model="$v.userAgenceForm.users.$model"
                          :multiple="true"
                          :options="users"
                          label="email"
                          track-by="id"
                          :searchable="false"
                          :closeOnSelect="false"
                          :user-select="true"
                          :disableUser="disableUserByEmail"
                          :class="{
                            'field-hasError': $v.userAgenceForm.users.$invalid
                          }"
                          :disabled="isVIEWER"
                        >
                          <template slot="caret">
                            <div
                              class="multiselect__select d-flex align-items-center justify-content-center"
                            >
                              <div>
                                <b-icon icon="chevron-down"></b-icon>
                              </div>
                            </div>
                          </template>
                        </multiselect>
                        <div
                          class="validation-field-holder"
                          v-if="
                            $v.userAgenceForm.users.$anyDirty &&
                              $v.userAgenceForm.users.$invalid
                          "
                        >
                          <small
                            v-if="!$v.userAgenceForm.users.required"
                            class="form-text text-danger"
                          >
                            {{ $t("required_field") }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="half-footer right-content">
                <div class="giga-button">
                  <button
                    v-if="
                      !getSimulation.users ||
                        getSimulation.users.length === 0 ||
                        editUser
                    "
                    :disabled="$v.userAgenceForm.$invalid"
                    class="giga-green_button no-icon"
                    @click="onPersistSubscription()"
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- MESSAGES -->
        <div
          class="col-xl-12 col-lg-12"
          v-if="getMessageries && getMessageries.length > 0"
        >
          <div class="giga-card  giga-margin-t_35">
            <h3 class="giga-card_title">Messages</h3>
            <template v-for="messagerie in getMessageries">
              <div class="giga-messenger" :key="messagerie.id">
                <div class="giga-messenger_container">
                  <div class="giga-messenger_row giga-messenger_left">
                    <div class="giga-messenger_message">
                      <div class="giga-messegner_thumb"></div>
                      <div class="giga-messegner_content">
                        <div class="message-content">
                          {{ messagerie.question }}
                        </div>
                        <div class="message-actions">
                          <div class="message-actions_col left-actions">
                            <span class="message-time">
                              {{
                                messagerie.creationDate
                                  ? moment(messagerie.creationDate, "x")
                                      .locale("fr")
                                      .format("dddd Do MMMM YYYY - HH:mm")
                                  : ""
                              }}
                            </span>
                          </div>
                          <div class="message-actions_col right-actions">
                            <ul class="message-actions_list">
                              <li class="message-actions_item">
                                <button @click="answerQuestion(messagerie)">
                                  Répondre
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="giga-messenger_row giga-messenger_right"
                    v-for="(history, index) in messagerie.messagerieHistory"
                    :key="`history-${messagerie.id}-${index}`"
                  >
                    <div class="giga-messenger_message">
                      <div class="giga-messegner_content">
                        <div class="message-content">
                          {{ history.answer }}
                        </div>
                        <div class="message-actions">
                          <div class="message-actions_col left-actions">
                            <span class="message-time">
                              {{
                                moment(history.creationDate, "x")
                                  .locale("fr")
                                  .format("dddd Do MMMM YYYY - HH:mm")
                              }}
                            </span>
                          </div>
                          <div class="message-actions_col right-actions">
                            <ul class="message-actions_list">
                              <li class="message-actions_item">
                                <button
                                  @click="modifyAnswer(messagerie, history)"
                                >
                                  Modifier
                                </button>
                              </li>
                              <li class="message-actions_item">
                                <button
                                  @click="
                                    openConfirmDeleteModal(
                                      messagerie.id,
                                      history.id
                                    )
                                  "
                                >
                                  Supprimer
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="giga-messegner_thumb"></div>
                    </div>
                  </div>
                  <div
                    class="giga-messenger_row giga-messenger_right"
                    v-if="messagerie.answer"
                  >
                    <div class="giga-messenger_message">
                      <div class="giga-messegner_content">
                        <div class="message-content">
                          {{ messagerie.answer }}
                        </div>
                        <div class="message-actions">
                          <div class="message-actions_col left-actions">
                            <span class="message-time">
                              {{
                                moment(messagerie.editionDate, "x")
                                  .locale("fr")
                                  .format("dddd Do MMMM YYYY - HH:mm")
                              }}
                            </span>
                          </div>
                          <div class="message-actions_col right-actions">
                            <ul class="message-actions_list">
                              <li class="message-actions_item">
                                <button @click="modifyAnswer(messagerie)">
                                  Modifier
                                </button>
                              </li>
                              <li class="message-actions_item">
                                <button
                                  @click="openConfirmDeleteModal(messagerie.id)"
                                >
                                  Supprimer
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="giga-messegner_thumb"></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- SEND -->
            <div class="giga-messenger_send-zone">
              <textarea
                class="send-zone"
                name=""
                id=""
                ref="sendZone"
                placeholder="Écrire votre message..."
                v-model="answer"
              ></textarea>
              <button class="send-button" @click="submitAnswer()">
                <span>Envoyer</span>
                <svg
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.4 17.4L18.85 9.92002C19.66 9.57002 19.66 8.43002 18.85 8.08002L1.4 0.600017C0.74 0.310017 0.00999999 0.800017 0.00999999 1.51002L0 6.12002C0 6.62002 0.37 7.05002 0.87 7.11002L15 9.00002L0.87 10.88C0.37 10.95 0 11.38 0 11.88L0.00999999 16.49C0.00999999 17.2 0.74 17.69 1.4 17.4Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirm-modal
      :id="modalId"
      :content="$t(modalContent)"
      :loader="false"
      fontSize="h3"
      backdrop-close="false"
      @yesClick="modelConfirm()"
      @close="hideConfirmationModal()"
    ></confirm-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { notificationService } from "../service/notification.service";
import { filter, map } from "lodash";
import pageLoader from "../../components/static/pageLoader.vue";
// import CollapseGroupedNotifications from '../../components/static/CollapseGroupedNotifications';
import ConfirmModal from "@/components/static/ConfirmModal";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import moment from "moment";
import { agenceService } from "@/views/service/agence.service";
import { estimationService } from "@/views/Simulations/services";
import { userService } from "@/views/service/user.service";
import { workService } from "@/views/Works/services";
import { constants } from "@/shared/constants";
import { helpers } from "@/shared/helper";

const CONFIRM_DELETE_ANSWER = "confirm-delete-answer";
export default {
  components: { ConfirmModal, pageLoader },
  name: "Overview",
  data() {
    return {
      currentModified: null,
      currentHistory: null,
      questionResponse: [],
      modifiedResponse: [],
      answer: "",
      modalId: "",
      modalContent: "",
      idAnswerToDelete: "",
      idHistoryToDelete: "",
      isEdit: false,
      moment,
      userAgenceForm: {
        agence: {},
        users: []
      },
      agences: [],
      users: [],
      editAgence: false,
      editUser: false,
      USER_TYPE: constants.USER_TYPE,
      ROLE_TYPE: constants.ROLE_TYPE
    };
  },
  validations: {
    userAgenceForm: {
      agence: {
        required: requiredIf(function() {
          return this.userInfo.clientType === this.USER_TYPE.B2B2B;
        })
      },
      users: {
        required
      }
    }
  },
  mounted() {
    this.getSimulationByIdAction({
      id: parseInt(this.$route.params["id"], 10)
    });
    setTimeout(() => {
      if (this.getSimulation.users?.length > 0) {
        this.$v.userAgenceForm.agence.$model = this.getSimulation.users?.[0]?.agence;
        this.$v.userAgenceForm.users.$model = this.getSimulation.users;
        if (this.userInfo.admin || !this.isVIEWER) {
          this.fetchUsersByAgency(this.getSimulation.users?.[0]?.agence);
        }
        if (this.userInfo.admin && !this.getSimulation.users?.[0]?.agence) {
          this.$v.userAgenceForm.agence.$model = -1;
          this.users = this.fetchUsersByAgency(-1);
          this.$v.userAgenceForm.users.$model = this.getSimulation.users;
        }
      } else {
        this.$v.userAgenceForm.agence.$model = null;
        this.$v.userAgenceForm.users.$model = null;
      }
      if (this.getSimulation.agence) {
        this.$v.userAgenceForm.agence.$model = this.getSimulation.agence;
      }
    }, 600);
    this.fetchAgences();
    this.fetchUsers();
    this.getWorkNotificationsAction({
      workId: parseInt(this.$route.params["id"], 10)
    });
    this.getContactsAction();
    this.questionResponse = [];
    this.modifiedResponse = [];
    this.getMessageries.forEach(msg => {
      this.questionResponse.push("");
      this.modifiedResponse.push("");
    });
  },
  computed: {
    ...mapGetters("loader", {
      workNotificationLoader: "getWorkNotificationLoader"
    }),
    ...mapGetters("simulation", ["getSimulation", "getMessageries"]),
    ...mapGetters("loader", { loading: "getLoading" }),
    ...mapGetters("loader", [
      "getLoadingModifyMessagerie",
      "getLoadingAddMessagerie"
    ]),
    ...mapGetters("notification", { notifications: "getWorkNotifications" }),
    ...mapGetters("contact", ["getContacts"]),
    ...mapGetters("account", { userInfo: "getCurrentUser" }),
    readOnly() {
      return {
        cursor:
          this.userInfo.admin ||
          this.userInfo.role?.roleType === this.ROLE_TYPE.ADMIN_AGENCE
            ? "pointer"
            : this.isViewerOrUser
            ? "no-drop"
            : "default"
      };
    },
    readOnlyOnUsers() {
      return {
        cursor: this.isVIEWER ? "no-drop" : "pointer"
      };
    },
    isNotB2B2B() {
      return helpers.isNotB2B2B();
    },
    usernameUsers() {
      return this.getSimulation.users
        .map(user => user.email.split("@")[0])
        .join(" , ");
    },
    isVIEWER() {
      return helpers.isVIEWER();
    },
    isViewerOrUser() {
      return (
        this.userInfo.role?.roleType === this.ROLE_TYPE.USER ||
        this.userInfo.role?.roleType === this.ROLE_TYPE.VIEWER
      );
    },
    disableUserByEmail() {
      return this.userInfo.role?.roleType === this.ROLE_TYPE.USER
        ? this.userInfo.email
        : null;
    }
  },
  methods: {
    ...mapActions("simulation", [
      "getSimulationByIdAction",
      "submitAnswerAction",
      "deleteAnswerAction",
      "submitModifiedAnswerAction"
    ]),
    ...mapActions("notification", [
      "getWorkNotificationsAction",
      "openModal",
      "closeModal"
    ]),
    ...mapActions("loader", [
      "showLoadingMessagerieLoaderAction",
      "hideLoadingMessagerieLoaderAction"
    ]),
    ...mapActions("contact", ["getContactsAction"]),
    markNotificationsAsRead(notificationsIds) {
      notificationService.markNotificationsAsRead(notificationsIds, true);
    },
    submitAnswer() {
      if (!this.currentModified) {
        this.currentModified = this.getMessageries[
          this.getMessageries.length - 1
        ];
      }
      const isEdit = this.isEdit;

      const messagerieDto = {
        answer: this.answer,
        isEdit: isEdit
      };
      if (this.currentHistory) {
        messagerieDto.historyId = this.currentHistory.id;
      }

      const payload = {
        questionId: this.currentModified.id,
        MessagerieAnswerDto: messagerieDto,
        workId: parseInt(this.$route.params["id"], 10)
      };

      if (isEdit) {
        this.submitModifiedAnswerAction(payload);
      } else {
        this.submitAnswerAction(payload);
      }

      this.answer = "";
    },
    doOpenConfirmModal() {
      setTimeout(() => {
        this.openModal({ instance: this.$root, id: this.modalId });
      }, 1);
    },
    openConfirmDeleteModal(idAnswer, idHistory) {
      this.idAnswerToDelete = idAnswer;
      this.idHistoryToDelete = idHistory;
      this.modalId = "confirm-delete-answer";
      this.modalContent = "would-you-like-to-delete-this-answer";
      this.doOpenConfirmModal();
    },
    hideConfirmationModal() {
      this.idAnswerToDelete = null;
      this.idHistoryToDelete = null;
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    modelConfirm() {
      this.questionResponse = [];
      this.deleteAnswerAction({
        questionId: this.idAnswerToDelete,
        historyId: this.idHistoryToDelete,
        workId: parseInt(this.$route.params["id"], 10)
      });
      this.hideConfirmationModal();
    },
    answerQuestion(msg) {
      this.currentModified = msg;
      this.answer = "";
      this.isEdit = false;
      this.$refs.sendZone.focus();
    },
    modifyAnswer(msg, history) {
      this.currentModified = msg;
      this.currentHistory = history;
      this.isEdit = true;
      this.answer = history ? history.answer : msg.answer;
    },
    fetchAgences() {
      agenceService.allUserAgencesList().then(res => {
        this.agences = res.content;
      });
    },
    fetchUsers() {
      if (this.isNotB2B2B) {
        userService.clientUsersByRole().then(users => {
          this.users = users;
        });
      }
    },
    async onChangeAgence(agency) {
      this.$v.userAgenceForm.users.$model = null;
      await this.fetchUsersByAgency(agency);
    },
    async fetchUsersByAgency(agency) {
      if (this.userInfo.clientType === this.USER_TYPE.B2B2B) {
        try {
          this.users = await userService.agenceUsersList(
            agency === -1 ? agency : agency.id
          );
          return this.users;
        } catch (error) {
          console.error(error);
        }
      } else {
        this.fetchUsers();
      }
    },
    onClickLabel() {
      if (this.userInfo.admin) {
        this.editAgence = true;
        this.editUser = true;
      } else if (this.userInfo.role?.roleType === this.ROLE_TYPE.ADMIN_AGENCE) {
        this.editAgence = false;
        this.editUser = true;
      } else if (this.userInfo.role?.roleType === this.ROLE_TYPE.USER) {
        this.editAgence = false;
        this.editUser = true;
      } else if (this.userInfo.role?.roleType === this.ROLE_TYPE.VIEWER) {
        this.editAgence = false;
        this.editUser = false;
      }
    },
    onPersistSubscription() {
      const data = {
        workId: this.$route.params["id"],
        users: this.$v.userAgenceForm.users.$model,
        agence: this.$v.userAgenceForm.agence.$model
      };
      workService.persistSubscription(data).then(() => {
        this.getSimulationByIdAction({
          id: parseInt(this.$route.params["id"], 10)
        });
        this.editAgence = false;
        this.editUser = false;
      });
    }
  },
  beforeDestroy() {
    this.markNotificationsAsRead(
      map(filter(this.notifications, { callToAction: false }), "id")
    );
  }
};
</script>

<style lang="scss" scoped>
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url("../../assets/images/bg-auth.svg");
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}

.comments-container {
  margin-top: 30px;
  .comment-row {
    display: flex;
    flex-wrap: wrap;
    margin: 30px 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .comment-col_s {
      flex: 0 0 70px;
      max-width: 70px;
    }
    .comment-col_l {
      flex: 0 0 calc(100% - 70px);
      max-width: calc(100% - 70px);
    }
    .user-comment {
      width: 80%;
      min-width: 500px;
      border: 2px solid #f4f7f9;
      padding: 20px;
      border-radius: 8px;
      @media (max-width: 768px) {
        max-width: 100%;
      }
      .user-comment-meta {
        display: flex;
        align-items: baseline;
        @media (max-width: 768px) {
          display: block;
        }
        .user-full_name {
          font-size: 18px;
        }
        .comment-date_time {
          font-size: 14px;
          padding-left: 15px;
          @media (max-width: 768px) {
            padding-left: 0;
          }
        }
      }
      .user-comment_content {
        margin: 15px 0 20px;
      }
      .comment-reply_field {
        .comment-reply_form {
          display: flex;
          flex-wrap: wrap;
          .comment-reply_input {
            flex: 0 0 calc(100% - 90px);
            max-width: calc(100% - 90px);
            background-color: #f4f4f4;
            border: 1px solid #f4f7f9;
            height: 50px;
            border-radius: 8px;
            padding-left: 15px;
            transition: all 0.2s linear;
            &:focus {
              border-color: #00588b;
            }
            @media (max-width: 768px) {
              flex: 0 0 100%;
              max-width: 100%;
            }
          }
          .comment-reply_submit {
            display: flex;
            margin-left: 15px;
            background: transparent;
            border: none;
            color: #808fa3;
            transition: all 0.2s linear;
            &:hover {
              color: #79b145;
            }
            @media (max-width: 768px) {
              margin-left: 0;
              margin-top: 20px;
            }
          }
        }
      }
    }
    .user-thumb {
      display: block;
      width: 50px;
      height: 50px;
      background-color: #000;
      border-radius: 50%;
      overflow: hidden;
    }
    .comment-actions {
      display: flex;
      justify-content: flex-start;
      margin-top: 20px;
      .comment-actions_list {
        margin: 0;
        padding: 0;
        .comment-action_item {
          position: relative;
          list-style-type: none;
          display: inline-block;
          padding: 0 10px;
          &::after {
            content: "";
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: #808fa3;
            display: block;
            position: absolute;
            top: 12px;
            right: -2px;
          }
          &:last-child::after {
            display: none;
          }
          button {
            display: flex;
            background: transparent;
            border: none;
            color: #808fa3;
            transition: all 0.2s linear;
            &:hover {
              color: #79b145;
            }
          }
        }
      }
    }
  }
  .right-comment {
    display: flex;
    justify-content: end;
    .comment-col_l {
      display: flex;
      justify-content: flex-end;
      .user-comment {
        margin-left: 0;
        .user-comment-meta {
          .comment-date_time {
            padding-left: 0;
            padding-right: 15px;
          }
        }
      }
      .comment-actions {
        justify-content: flex-end;
      }
    }
    .comment-col_s {
      display: flex;
      justify-content: flex-end;
    }
  }
}
.right-content {
  display: flex;
  justify-content: flex-end;
}
.input-field_area {
  width: 300px;
}
.label-users {
  color: #132d48;
  font-size: 18px;
  font-weight: 600;
}
.assign-div {
  height: 100%;
}
.field-hasError {
  box-shadow: 0px 0px 3px 0px #e90e00 !important;
}
</style>
